import React from 'react';
import { BsFormControl, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';

export default function ClienteModal(props) {
    const isNew = props.idCliente < 1;

    const updateData = async () => await apiGet("clientes/get/" + props.idCliente);

    const checkData = formData => {
        let errors = {};
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("clientes/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo cliente" : "Editar cliente"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <ClienteForm />
        </BsModalForm>
    );
}

function ClienteForm(props) {
    const data = props.data;
    const errors = props.errors;
    return (
        <BsFormControl
            /* Nombre */
            label="Nombre" name="name"
            value={data.name} error={errors.name}
            maxLength="100" />
    );
}
